import { render } from "./DetailedStatistic.vue?vue&type=template&id=6e7092a3&scoped=true"
import script from "./DetailedStatistic.vue?vue&type=script&lang=js"
export * from "./DetailedStatistic.vue?vue&type=script&lang=js"

import "./DetailedStatistic.vue?vue&type=style&index=0&id=6e7092a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7092a3"]])

export default __exports__